// Video section (content-sections.md §2.9): the poster and caption stay on the page; play opens the video in a modal
// dialog, and closing the dialog unloads the player.
if (!customElements.get('royalty-video')) {
  customElements.define(
    'royalty-video',
    class RoyaltyVideo extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-play-button], [data-play-icon], [data-poster]')) {
            event.preventDefault();
            this.open();
          }
        });
      }

      open() {
        const src = this.dataset.videoSrc;
        if (!src) return;
        if (!this.dialog) this.dialog = this.build();
        this.dialog.querySelector('[data-video-element]').replaceChildren(this.media(src));
        this.dialog.showModal();
      }

      build() {
        const dialog = document.createElement('dialog');
        dialog.className = 'video-modal';
        dialog.setAttribute('aria-label', this.dataset.title);
        dialog.innerHTML = `<button type="button" class="video-modal__close" aria-label="Close video"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg></button><div class="video-modal__player" data-video-element></div>`;
        dialog.style.setProperty('--video-ratio', this.style.getPropertyValue('--video-ratio'));
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog || event.target.closest('.video-modal__close')) dialog.close();
        });
        dialog.addEventListener('close', () => dialog.querySelector('[data-video-element]').replaceChildren());
        this.append(dialog);
        return dialog;
      }

      media(src) {
        const muted = this.dataset.muteVideo === 'true';
        const loop = this.dataset.autoloop === 'true';
        const controls = this.dataset.controls !== 'false';
        if (this.dataset.provider === 'html5') {
          const video = document.createElement('video');
          Object.assign(video, { src, playsInline: true, muted, loop, controls, autoplay: true });
          return video;
        }
        const youtube = this.dataset.provider === 'youtube';
        const iframe = document.createElement('iframe');
        const params = youtube
          ? `autoplay=1&playsinline=1&modestbranding=1&rel=0&mute=${muted ? 1 : 0}&controls=${controls ? 1 : 0}${loop ? `&loop=1&playlist=${src}` : ''}`
          : `autoplay=1&playsinline=1&muted=${muted ? 1 : 0}&loop=${loop ? 1 : 0}&controls=${controls ? 1 : 0}`;
        iframe.src = youtube ? `https://www.youtube.com/embed/${src}?${params}` : `https://player.vimeo.com/video/${src}?${params}`;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.title = this.dataset.title;
        return iframe;
      }
    }
  );
}
